<style lang="scss" scoped>
.content-wrapper {
  display: flex;
  height: 100%;
  position: relative;
}
.btn-send {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b8bfc5;
  border-radius: 0;

  &:hover {
    color: $gray-900;
    background-color: rgba(0, 0, 0, 0.1);
  }
}
.dialog-message-input-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}
.dialog-loading {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  font-size: 50px;
  z-index: 1;
  color: #fff;
}
.dialog-message-input {
  min-width: 0;
  flex-grow: 0;
  border-radius: 15px;
  margin: 8px 5px;
  height: 32px;

  &::placeholder {
    color: #c5c5c5;
  }
}
.dialog-message-characters {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  color: #b3aeb4;
  padding: 0.375rem 0.75rem;
  white-space: nowrap;
}
.dialog-message-submit {
  flex-grow: 1;
  margin: 6px 5px;
  border-radius: 8px;
  padding: 5px;
}
.dialog-inputs {
  background-color: #f2f2f2;
}

@media (max-width: 1200px) {
  .dialog-inputs {
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .dialog-message-input-wrapper {
    flex-wrap: wrap;
  }
  .dialog-message-input {
    width: 100%;
  }
  .dialog-message-characters {
    width: 50%;
    margin: 0;
    font-size: 70%;
  }
  .dialog-message-submit {
    width: 50%;
    white-space: normal;
    margin: 0;
    font-size: 70%;
  }
}

.no-border {
  border: 0px;
}
</style>

<template>
  <div class="content-wrapper flex-column justify-content-between">
    <div v-if="showLoading" class="dialog-loading">
      <i class="fas fa-spinner fa-pulse"></i>
    </div>
    <section>
      <form
        @submit.prevent="sendTextMessage"
        action
        class="d-flex dialog-inputs"
      >
        <div class="col">
          <div class="row">
            <div v-for="(message, index) in messagesOnHold" :key="index">
              <span
                class="p-1 border border-primary bg-primary text-white rounded"
              >
                Nachricht-{{ index }}
                <button
                  class="bg-primary no-border text-danger"
                  @click="removeMessage(index)"
                >
                  X
                </button>
              </span>
            </div>
          </div>
          <div class="row">
            <dialog-text-area
              ref="messageInput"
              @keyup="setLastCursorPosition"
              :onEnter="sendTextMessage"
              @click="setLastCursorPosition"
              type="text"
              class="form-control dialog-message-input"
              v-model="message"
              placeholder="Schreibe eine Nachricht"
            >
            </dialog-text-area>
          </div>
          <div class="row">
            <chat-input-buttons
              @add-emoji="addEmoji"
              @send-blink="addSpecialMessage(3, null)"
              @send-gif="addGif"
              @send-gift="addGift"
              @send-image="sendPrivateImage"
              :enableSending="messageSent"
              :disabled="hasSpecialMessage"
            ></chat-input-buttons>
            <div class="dialog-message-input-wrapper">
              <div class="dialog-message-characters">
                <span
                  >{{ messageLength >= messageMinLength ? "+" : ""
                  }}{{ messageLength - messageMinLength }} Zeichen</span
                >
              </div>
              <button
                type="submit"
                :disabled="disableSend"
                class="dialog-message-submit btn btn-primary"
              >
                Senden
              </button>
              <button
                type="button"
                @click="addMessage"
                :disabled="disableAddButton"
                class="dialog-message-submit col-1 btn btn-primary"
              >
                +1
              </button>
            </div>
          </div>
        </div>
      </form>
    </section>
    <dialog-scroller
      :mirror="true"
      :idPartner="idPartner"
      :profile="profile"
      :support="false"
      @loading="loading = arguments[0]"
      :moderator="true"
    ></dialog-scroller>
  </div>
</template>

<script lang="babel">
import DialogScroller from "@/components/DialogScroller.vue";
import DialogTextArea from '@/components/DialogTextArea.vue';
import ChatInputButtons from '@/components/Customer/chat/ChatInputButtons.vue';
import moment from "moment";

export default {
  components: {
    DialogScroller,
    DialogTextArea,
    ChatInputButtons
  },
  props: {
    isAsa: {
      required: true,
      type: Boolean
    },
    idPartner: {
      required: true,
    },
    profile: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      message: "",
      lastCursorPosition: 0,
      loading: false,
      messageSent: true,
      messagesOnHold: [],
      type: null,
      meta: null,
      placeholder:"",
      disableInput: false,
      maxMessageCount: 2,
      hasSpecialMessage: false
    };
  },
  computed: {
    lastMessageIsSpecial() {
      if(this.messagesOnHold.length > 0)
        return this.messagesOnHold[this.messagesOnHold.length -1].type !== null
      else
        return false;
    },
    disableAddButton() {
      return !this.canSendMessage && !this.disableInput || (this.messagesOnHold.length >= 1);
    },
    textMessageNeedeed() {
      return ( (Boolean(Laravel.settings.multipleMessagesIfAsa) && this.isAsa) ||
        (Boolean(Laravel.settings.multipleMessagesIfgeneralMessage) && !this.isAsa) );
    },
    hasMessage() {
      return this.messagesOnHold.length > 0;
    },
    hasEnoughTextMessages() {
      if (this.textMessageNeedeed) {
        let specialMessages = this.messagesOnHold.filter(message => {
          return (message.type !== null);
        });
        let textMessages = this.messagesOnHold.filter(message => {
          return (message.type === null);
        });
        let curTextMessage = this.canSendMessage ? 1 : 0;
        let numOfMessagesNeeded = specialMessages.length > 0 ? specialMessages.length: 1;
        return (textMessages.length + curTextMessage) >= numOfMessagesNeeded;
      } else {
        return this.messagesOnHold.length > 0 || this.canSendMessage;
      }
    },
    messageLength () {
      return this.message.length;
    },
    charsToNextMessage() {
      if (this.messageCount === 0) {
        return 300;
      }
      return (300 * this.messageCount);
    },
    messageCount() {
      return Math.ceil(this.message.length / 300);
    },
    addTextMessage() {
      return (!this.hasEnoughTextMessages && this.hasMessage && this.disableInput);
    },
    currency() {
      return Laravel.lang.currency;
    },
    pricePerMessage(){
      return Laravel.settings.pricePerMessage;
    },
    messageMinLength() {
      return this.isAsa
        ? Laravel.settings.minModeratorAsaChars
        : Laravel.settings.minModeratorMessageChars;
    },
    totalPrice() {
      return this.pricePerMessage * this.messageCount;
    },
    showLoading() {
      return this.loading && this.$store.getters["message/dialog"](this.idPartner, this.profile.id).length === 0;
    },
    canSendMessage() {
      return this.message.trim().length > 0
        && this.messageSent
        && (this.messageLength >= this.messageMinLength);
    },
    disableSend() {
      return (!this.canSendMessage && !this.disableInput ) || (!this.hasEnoughTextMessages);
    }
  },
  methods: {
    messageType(type) {
      let mtype = type ? type : 0;
      let types = {
        0: 'Freundschafts-Anfrage',
        1: 'GIF-Nachricht',
        2: 'Geschenk',
        3: Laravel.settings.blinkName + ' Nachricht',
        4: 'Bild-Nachricht',
      }
      return types[mtype];
    },
    send() {

      if(this.message) {
        let message = {
          type: null,
          meta: this.meta,
          body: this.message,
          message: this.message,
          receiver_id: this.idPartner,
          sender_id: this.profile.id,
          created_at: moment(),
        };

        this.messagesOnHold.push(message);
      }

      this.messageSent = false;
      let timeReference = this.messagesOnHold[this.messagesOnHold.length-1].created_at;
      this.messagesOnHold.forEach(element => {
        element.delta = Math.floor(moment.duration(moment(timeReference).diff(element.created_at)).asSeconds());
        delete element.created_at;
      });
      this.$http.post( "/api/v1/message/all", {
            messages: this.messagesOnHold,
        }).then(()=> {
          this.$store.commit("dialog/update", [this.messagesOnHold[0].receiver_id]);
          this.$emit('message-sent');
        }).finally(()=>{
          this.messageSent = true;
      });
    },
    addMessage() {
      if (!this.disableInput && this.canSendMessage) {
        let message = {
          type: null,
          meta: this.meta,
          body: this.message,
          message: this.message,
          receiver_id: this.idPartner,
          sender_id: this.profile.id,
          created_at: moment(),
        };
        this.messagesOnHold.push(message);
      }
      this.disableInput = false;
      this.message ="";
      this.$refs.messageInput.$el.focus();
    },
    setLastCursorPosition(event) {
      this.lastCursorPosition = event.target.selectionStart;
    },
    addEmoji(e) {
      if (this.lastCursorPosition > this.message.length) {
        this.lastCursorPosition = 0;
      }
      this.message = this.message.substr(0,this.lastCursorPosition) + e.colons + this.message.substr(this.lastCursorPosition);
      this.$refs.messageInput.$el.focus();
    },
    sendTextMessage() {
      // if last message is special the input is disabled and sendMessage can only get fired if messagesOnHold keeps enaougth text messages
      if (this.canSendMessage){
        let message = {
          type: null,
          meta: this.meta,
          body: this.message,
          message: this.message,
          receiver_id: this.idPartner,
          sender_id: this.profile.id,
          created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        };
        this.messagesOnHold.push(message);
        this.message = "";
      }
      else if (this.lastMessageIsSpecial) {
        this.message = "";
      }

      if (this.hasEnoughTextMessages) {
        this.send();
      }

    },
    addSpecialMessage(type = null, meta = null) {
      let message = {
          type: type,
          meta: meta,
          body: ' ',
          message: this.message,
          receiver_id: this.idPartner,
          sender_id: this.profile.id,
          created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
      };
      this.messagesOnHold.push(message);
      this.hasSpecialMessage = true;
      this.$refs.messageInput.$el.focus();
    },
    removeMessage(id) {
      if(this.messagesOnHold[id]) {
        if(this.messagesOnHold[id].type == 1 || this.messagesOnHold[id].type == 2 || this.messagesOnHold[id].type == 3) {
          this.hasSpecialMessage = false;
        }
        this.messagesOnHold.splice(id, 1);
        console.log("Item removed");
      } else {
        console.log("Nicht im Array") ;
      }
    },
    addGif(url) {
      this.addSpecialMessage(1, {
        url,
      });
    },
    addGift(giftId) {
      this.addSpecialMessage(2, {
        giftId,
      });
    },
    addBlink() {
      this.addSpecialMessage(3);
    },
    sendPrivateImage(image){
      let message = {
          type: 4,
          meta: image.id,
          body: ' ',
          message: ' ',
          receiver_id: this.idPartner,
          sender_id: this.profile.id,
          created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        };
      this.messagesOnHold.push(message);
    }
  },
  mounted() {
    this.$refs.messageInput.$el.focus();
  },
  watch: {
    lastMessageIsSpecial() {
      if (this.lastMessageIsSpecial) {
        this.disableInput = true;
      }
    }
  }
}
</script>
